/**
 * The value to store as an account's manual name when the user renames it.
 * A blank name, or one matching the bank's, clears the rename so the account
 * follows the bank's name again.
 */
export function manualAccountName(
  newName: string,
  originalName: string,
): string | null {
  const trimmed = newName.trim();
  return trimmed === "" || trimmed === originalName ? null : trimmed;
}
